import * as api from '../../api';
import * as store from '../../reducers/store';
import {
  getLastPageFormField,
  getLastPageFormSet,
  getLastPageForm,
} from '../../utils/formSet';
import { Page } from '../Form/Page';
import { fullPagePrimitive } from '../../components/utils';
import VirtualVisitPage from '../Form/VirtualVisitPage';

import styles from '../FormStart/index.module.css';

const { Primitive } = api.PrevisitFormTemplateFieldConfig;

interface Props {
  formSets: store.FormSets;
  practicePreference: api.Previsit.PracticePreference;
}

export const PrimitiveLastPage: React.FC<Props> = ({
  formSets,
  practicePreference,
}) => {
  const formSet = getLastPageFormSet(formSets);
  const field = getLastPageFormField(formSets);
  const form = getLastPageForm(formSets);
  if (!field || !formSet || !form) return null;

  const renderPrimitive = () => {
    const { encounter, provider, practice } = formSet;
    switch (field.primitive) {
      case Primitive.VirtualVisitInstructions:
        if (!encounter || !provider || !practice) return <></>;
        return (
          <VirtualVisitPage
            formField={field}
            encounter={encounter}
            provider={provider}
            practice={practice}
            setFormField={() => {}}
            navigateToNextPage={async () => {}}
            handleLastPage={async () => {}}
          />
        );
      default:
        return (
          <Page
            page={field.page}
            practicePreference={practicePreference}
            formFields={form.fields}
            formSetId={field.previsitFormSetId}
            navigateToNextPage={async () => {}}
            handleLastPage={async () => {}}
          />
        );
    }
  };

  return (
    <div
      className={[
        fullPagePrimitive(field.primitive)
          ? styles.FormContentFullWidth
          : styles.FormContent,
      ].join(' ')}
    >
      {renderPrimitive()}
    </div>
  );
};
